function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M111.6 20.3h5.9c5.5 0 10-4.7 10-10.2V10c0-5.5-4.5-9.7-10-9.7h-5.9v5.4h5.9c2.4 0 4 2 4 4.4 0 2.4-1.4 4.7-4 4.7h-5.9v5.5z",
  fill: "#EF5964"
}), React.createElement("path", {
  d: "M95.1 15.8c-.2-.4-.5-.5-.9-.5h-4.5c-.5 0-.8.3-.8.7l2.5 5.1H79.3v5.4h14.5l2.1 4.4c.2.5.5.8 1 .8h4.5s1.1 0 .7-.9l-7-15z",
  fill: "#EF5964"
}), React.createElement("path", {
  d: "M92.3.7c-.1-.2-.4-.2-.7-.2h-4.5s-.8 0-1 .4L72.4 30.8c-.1.2 0 .3.1.5s.3.2.5.2h4.5c.4 0 .8-.5 1-.9L92.4 1c0-.2 0-.3-.1-.3z",
  fill: "#E62245"
}), React.createElement("path", {
  d: "M77 4.5C74.4 2.1 71 0 65.3 0c-8.8 0-15.8 7.1-15.8 15.9 0 8.4 7.3 15.5 14.8 15.7 0 0 .5 0 .7-.4l2.1-4.6s.2-.3-.1-.5c-.1-.1-.6-.1-.6-.1-5.6-.1-10.9-4.4-10.9-10.1 0-5.7 4.5-10.3 10.1-10.3 4.1 0 6.6 2.1 8.5 3.8 0 0 .3.2.5.2s.3-.2.3-.2L77 5c.3-.3 0-.5 0-.5z",
  fill: "#EF5964"
}), React.createElement("path", {
  d: "M36.6 13.1c-3.6-1.4-5.3-2.9-5.3-4.9 0-1.4 1.4-3.1 4-3.1 2.4 0 5.9 2.1 6.4 2.3.5.3 1 .3 1.3-.4l1.3-3c.3-.5.1-1.1-.3-1.3C43.1 2 40.2 0 35.5 0c-7 0-10 4.6-10 8.6 0 5.3 4.2 7.9 8.4 9.6 3.7 1.5 5.6 3.1 5.6 5.3 0 1.9-1.8 3.4-4.1 3.4-2.9 0-6.7-2.7-6.9-3-.5-.3-1.2-.3-1.5.3l-1.3 3c-.3.8-.2.9.2 1.3.9.9 4.2 3.5 9.8 3.5 6.3 0 10.2-4.2 10.2-8.8.1-5.8-5-8.4-9.3-10.1z",
  fill: "#E62245"
}), React.createElement("path", {
  d: "M1.1 18.4c-.2 0-.2 0-.2-.3v-4.5c0-.2 0-.3.2-.3h16.2c.2 0 .2.1.2.3V18c0 .2 0 .3-.2.3H1.1v.1z",
  fill: "#EF5964"
}), React.createElement("path", {
  d: "M19.6 5.8c.2 0 .3-.1.3-.4V.9c0-.2-.1-.5-.3-.5H1C.7.4.5.6.5 1.1v30.1c0 .2.1.4.3.4h18.6c.2 0 .3-.1.3-.3v-4.5c0-.2-.1-.3-.3-.3H6V5.8h13.6z",
  fill: "#E62245"
}), React.createElement("path", {
  d: "M132.5 18.4c-.2 0-.2 0-.2-.3v-4.5c0-.2 0-.3.2-.3h16.2c.2 0 .2.1.2.3V18c0 .2 0 .3-.2.3h-16.2v.1z",
  fill: "#EF5964"
}), React.createElement("path", {
  d: "M151.2 26.5h-13.7V5.8H151c.2 0 .3-.1.3-.4V.9c0-.2-.1-.5-.3-.5h-18.5c-.3 0-.5.2-.5.7v30.1c0 .2.1.4.3.4h18.8c.2 0 .4-.1.4-.3v-4.5c.2-.3-.1-.3-.3-.3z",
  fill: "#E62245"
}), React.createElement("path", {
  d: "M111.6.3H107c-.3 0-.5.2-.5.5V31c0 .3.2.5.5.5h4.7c.3 0 .5-.2.5-.5V.2h-.6v.1z",
  fill: "#E62245"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 152 32",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.9eb142be.svg";
export { ForwardRef as ReactComponent };